import { render, staticRenderFns } from "./OrderList2.vue?vue&type=template&id=5d53defe&"
import script from "./OrderList2.vue?vue&type=script&lang=js&"
export * from "./OrderList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports